import { render, staticRenderFns } from "./InputPolyglotEditor.vue?vue&type=template&id=f491b5b0"
import script from "./InputPolyglotEditor.vue?vue&type=script&lang=js"
export * from "./InputPolyglotEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports